import { Vertical } from './entities';
import { Subscribable } from '@benzinga/subscribable';
import { VerticalsRequestEvent } from './manager';
export class VerticalsStore extends Subscribable<VerticalsRequestEvent> {
  private verticals: Vertical[];
  constructor() {
    super();
    this.verticals = [];
  }

  public compareVerticals = (lhs: Vertical[], rhs: Vertical[]): boolean => {
    if (lhs.length !== rhs.length) {
      return false;
    }
    return lhs.every(vertical => {
      const newVertical = rhs.find(newVertical => vertical.verticalName === newVertical.verticalName);
      if (newVertical) {
        return vertical.verticalSymbols.length === newVertical.verticalSymbols.length;
      } else {
        return false;
      }
    });
  };

  public getVerticalStoreVerticals = (): Vertical[] => {
    return this.verticals ?? [];
  };

  public getCachedVerticalByVerticalName = (verticalName: string): Vertical | undefined =>
    this.verticals.find(vertical => vertical.verticalName === verticalName);

  public updateVerticals = (verticals: Vertical[]): Vertical[] => {
    const areVerticalsEqual = this.compareVerticals(this.verticals, verticals);
    if (areVerticalsEqual) return verticals;
    this.verticals = verticals;
    this.dispatch({
      type: 'verticals:update_verticals',
      verticals,
    });
    return verticals;
  };
}
